import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvResumableFeedPeristence = new MMKV({
  id: MMKVStoreKeyMap.resumableFeedStore,
});

export const zustandResumableFeedStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvResumableFeedPeristence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvResumableFeedPeristence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvResumableFeedPeristence.delete(name);
  },
};
